import {
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  IconButton,
  Typography
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React, { useContext } from "react";
import { Context } from "../../../Context/context";
import { baseStyle } from "../../../theme";
import { resolutions, menuID } from "../../../TypesAndConstants/const";
import { CanvasResolution } from "../../../TypesAndConstants/types";
import { aspectToPixel } from "../../../History/ResponsiveUtilities";
import { THREE_INST } from "../../SketchUtilities/Three/threeSingleton";

const cardSize = 150;

export default function ResolutionSelect() {
  const { state, dispatch } = useContext(Context);
  const styles = baseStyle({});

  const close = () => {
    dispatch({ type: "set_active_menu", value: "none" });
  };

  const threeInst = THREE_INST.getInst();

  const resolutionItem = (res: CanvasResolution) => {
    const cardWidth = cardSize * res.aspectRatio;
    return (
      <Card
        elevation={4}
        style={{
          margin: "10px 0px",
          height: `${cardSize}px`,
          width: `${cardWidth}px`
        }}
        key={res.name}
      >
        <CardActionArea
          className={styles.cards}
          onClick={(e) => {
            threeInst.obj.handleResolutionSwitch();
            dispatch({ type: "set_canvas_resolution", value: res });
            dispatch({
              type: "set_dimensions",
              value: aspectToPixel(
                res.aspectRatio,
                state.dimensions,
                res.name === "Square"
              )
            });
            close();
            e.stopPropagation();
            e.preventDefault();
            return false;
          }}
          style={{ height: "100%" }}
        >
          <CardContent>
            <Typography gutterBottom variant="h5" component="h2">
              {res.name}
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              {res.description}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  };

  return (
    <Card
      elevation={6}
      className={`${styles.resolutionContainer} ${styles.background}`}
      id={menuID.NewCanvas}
    >
      <CardHeader
        action={
          <IconButton
            color="primary"
            aria-label="Select Canvas Size"
            onClick={close}
            size="large">
            <HighlightOffIcon />
          </IconButton>
        }
        title="Select Canvas Size"
      />
      <CardContent>
        {resolutions.map((i: CanvasResolution) => {
          return resolutionItem(i);
        })}
      </CardContent>
    </Card>
  );
}
